




























import Engine, { Booster as BoosterEnum, Event } from "@gaia-project/engine";
import { boosterEvents } from "@gaia-project/engine/src/tiles/boosters";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { eventDesc } from "../data/event";
import TechContent from "./TechContent.vue";

@Component<Booster>({
  components: {
    TechContent,
  },
})
export default class Booster extends Vue {
  @Prop()
  booster: BoosterEnum;

  @Prop()
  disabled: boolean;

  @Prop({ default: false, type: Boolean })
  highlighted: boolean;

  get tileObject(): Event[] {
    return boosterEvents(this.booster);
  }

  get event1() {
    return this.tileObject[0];
  }

  get event2() {
    return this.tileObject[1];
  }

  get title() {
    return this.booster;
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get tooltip() {
    return `- ${eventDesc(this.event1, this.engine.expansions)}\n- ${eventDesc(this.event2, this.engine.expansions)}`;
  }
}
